/**
 * chartYData: 图的数据（纵坐标）
 * formatterfunc：浮窗
 * chartId：容器id
 * lengendArr：图例数组，不传则为单线，切不展示图例，传一个也是单线,但是展示图例
 * chartXData：横坐标数组
 * loading: 加载状态，需要chart的加载效果可传
 */
import React, { useRef, useState, useEffect, useMemo } from 'react';
import moment from 'moment';
import { useMemoizedFn, useDeepCompareEffect } from 'ahooks';
// import * as echarts from 'echarts';
// import * as moment from 'moment';
import { mathFormat, showTimeByDateType, hanPullOffTime } from '@/pages/intelligence/utils/commonUtils';
import { handleSerieSymbolConfig } from '@intelligence/utils/echartsUtils';
import databrain from '@/pages/intelligence/assets/svg/dataSource/databarin.svg';
import appnnie from '@/pages/intelligence/assets/svg/dataSource/appnnie.svg';
import sensortower from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import './index.scss';
import { TIMETYPETOLY } from '@/pages/intelligence/utils/common';
import { ECHARTSCOLOR, PREDICT_DATA_SVG_ICON } from '@/pages/intelligence/utils/echartsConst';
import ChartBubble from "@/pages/intelligence/components/ChartBubble";
import ChartsIndex, { IChartsIndexInstance } from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import OpinionBarAndLineChart from '@intelligence/v3/components/OpinionBarAndLineChart';
import { useIntl } from 'umi';

const platformMap: { [key: string]: any } = {
  appannie: 'data.ai',
  databrain: 'DataBrain',
  sensortower: 'Sensor Tower',
} as any;

const showUnit = ['revenue', 'Revenue'];
const LineChart = (props: any = {}) => {
  const {
    chartYData = [],
    chartXData,
    lengendArr = [],
    colorArr = ECHARTSCOLOR,
    dateType = 'Day',
    currentType,
    predictArr = [],
    platform,
    isPolishing = true, //用于识别折线图中是否存在补齐数据,当没有补齐数据时不显示图例（目前仅在mobile模块中传入）
    baseReleaseTime,
    isShowReleaseTime = false,
    earliestPeriod,
    islowerGame,
    lowerGameTime,
    dateValue,
    predictByDayArr,
    trendLoading,
    enableOpinionEventAnnotation = false,
    controlledEventAnnotation,
  } = props;

  // console.log('LineMarkClickChart', props);

  const chartsInstance = useRef<IChartsIndexInstance>(null);
  const [chartXDataList, setChartXDataList] = useState(chartXData || []);
  const [chartYDataList, setChartYDataList] = useState(chartYData || []);
  // const [lineOption, setLineOption] = useState({});
  const { formatMessage } = useIntl(); // 中英切换方法
  const lineFormatterTooltip = (params: any[]) => {
    // console.log('paramsparamsparams',params);
    // let _dateTitle = params[0]?.axisValue;
    let _needCondig = params?.filter((item: any) => item?.data != '-');
    let isPredict = false;
    // 需要展示的图例显示信息
    // let _validConfig = _needCondig?.filter((item: any) => {
    //   isPredict = predictByDayArr[item.dataIndex] === 1;
    //   // if ((isPredict && item.color == '#FBB545') || !isPredict) {
    //   //   return true;
    //   // }
    //   // 第一个serie是正常数据的，第二个serie是补齐数据，这里filter的目的是 保证tooltip里 正常数据和补齐数据不会在同一天出现
    //   if ((isPredict && item?.seriesIndex === 1) || (!isPredict && item?.seriesIndex === 0)) {
    //     return true;
    //   }
    //   return false;
    // })
    return ChartBubble({
      // data: _validConfig,
      data: _needCondig,
      topChartsType: 'stats-activeuser',
      chartType: 'line',
      platform: isPredict ? 'ogdb' : platform,
      dateType,
    })
  }

  /**数据异步： fix 切换到RANK时应该展示2条折线图 */
  useEffect(() => {
    setChartXDataList(chartXData)
    setChartYDataList(chartYData)
  }, [JSON.stringify(chartXData), JSON.stringify(chartYData)])

  let maxY: number;

  const returnSeries = () => {
    if (lengendArr?.length > 0) {
      let series: any = []
      lengendArr?.forEach((item: any, i: number) => {
        // 是否有补齐数据
        if (!predictArr[i]) {
          predictArr[i] = []
        }
        let predict: boolean = predictArr[i].some((subitem: boolean) => subitem);
        let a: any = []
        let b: any = []
        if (chartYDataList && Array.isArray(chartYDataList) && chartYDataList?.length > 0) {
          // console.log('chartYDataList', chartYDataList);
          if (chartYDataList[i] && Array.isArray(chartYDataList[i]) && chartYDataList[i]?.length > 0) {
            chartYDataList[i]?.forEach((itemChart: any, iChart: number) => {
              if (predictArr[i][iChart] !== 1) { // 当天没有补齐数据
                a.push(itemChart)
                b.push('-')
              } else { // 当天有补齐数据
                // // 前一天或者后一天都是补齐数据，countA 才填 '-'
                // // 两条线才能连上
                // if (iChart !== 0 && iChart !== chartYDataList?.length) { // 当前不是第一天或者最后一天
                //   if (predictArr[i][iChart - 1] && predictArr[i][iChart + 1]) {
                //     a.push('-')
                //   } else {
                //     a.push(itemChart)
                //   }
                // } else if (iChart === 0 && predictArr[i]) { // 当前是第一天
                //   if (predictArr[i][iChart + 1]) {
                //     a.push('-')
                //   } else {
                //     a.push(itemChart)
                //   }
                // } else if (iChart === chartYDataList?.length && predictArr[i]) { // 当前是最后一天
                //   if (predictArr[i][iChart - 1]) {
                //     a.push('-')
                //   } else {
                //     a.push(itemChart)
                //   }
                // }
                // b.push(itemChart)

                if (showPredict) {
                  // 前一天或者后一天都是补齐数据，countA 才填 '-'
                  // 两条线才能连上
                  if (iChart === 0) {
                    if (predictArr[i][iChart + 1]) {
                      a.push('-');
                    } else {
                      a.push(itemChart);
                    }
                  } else if (iChart === chartYDataList?.[i]?.length - 1) {
                    if (predictArr[i][iChart - 1]) {
                      a.push('-');
                    } else {
                      a.push(itemChart);
                    }
                  } else {
                    if (predictArr[i][iChart - 1] && predictArr[i][iChart + 1]) {
                      a.push('-');
                    } else {
                      a.push(itemChart);
                    }
                  }
                  b.push(itemChart);
                } else {
                  if (predictArr[i][iChart] !== 1) {
                    a.push(itemChart);
                  } else {
                    a.push('-');
                  }
                  b.push('-');
                }
              }
            });
          }
        }
        let serie = {
          isPredict: false,
          name: item || '',
          type: 'line',
          showSymbol: false,
          symbol: 'circle',
          symbolSize: 10,
          lineStyle: {
            type: 'solid',
          },
          data: a,
          // data: chartYDataList[i],
          yAxisIndex: item === 'Rank' ? 1 : 0
        }

        if (isShowReleaseTime) {
          let objTemp = {
            symbol: ['none', 'none'],
            itemStyle: {
              normal: {
                lineStyle: {
                  type: 'dashed',
                  color: '#0053B2',
                  opacity: 0.54
                },
              }
            },
            data: [{
              name: formatMessage({ id: 'dbi_since_release' }),
              xAxis: baseReleaseTime,
              label: {
                position: 'end',
                show: true,
                textStyle: {
                  color: '#0053B2',
                  fontSize: 12,
                  opacity: 0.54
                },
                padding: [0, 0, -55, 0],
                formatter: function (item: any) {
                  return item.name
                }
              }
            },
            {
              name: formatMessage({ id: 'dbi_earliest_data' }),
              xAxis: earliestPeriod,
              label: {
                position: 'end',
                show: true,
                textStyle: {
                  color: '#0053B2',
                  fontSize: 12,
                },
                padding: [0, 0, -25, 0],
                formatter: function (item: any) {
                  return item.name
                }
              }
            }]
          };
          serie = { ...serie, markLine: objTemp };
        }

        //Off the Shelves   已不需要
        //此处备份
        // {
        //   "game_id": "u38f0f8a7dcb2ed5e48c9e9fa6c1ab50b",
        //   "pull_off_time": ["2022-10-01", "2022-10-11"]
        // }
        // if (islowerGame && dateType == 'Day' && hanPullOffTime(dateValue, lowerGameTime)) {
        //   let markTemp = {
        //     silent: true,
        //     itemStyle: {
        //       opacity: 0.5,
        //       color: "#f0f0f0"
        //     },
        //     label: {
        //       show: true,
        //       formatter: ['Off the Shelves'].join('\n'),
        //       color: "#9b9d98",
        //       position: 'inside',
        //       align: 'center',
        //       verticalAlign: 'middle',
        //       overflow: "break",
        //     },
        //     data: [
        //       [
        //         {
        //           xAxis: lowerGameTime[0]
        //         },
        //         {
        //           xAxis: moment(lowerGameTime[1]).valueOf() > moment(dateValue[1]).valueOf() ? dateValue[1] : lowerGameTime[1]
        //         }
        //       ]
        //     ],
        //   };
        //   serie = { ...serie, markArea: markTemp };
        // }

        series.push(serie)
        if (predict) {
          let pSerie = {
            // name: item || '',
            isPredict: true,
            name: `Predicted ${item}` || '',
            type: 'line',
            showSymbol: false,
            symbol: 'circle',
            symbolSize: 10,
            lineStyle: {
              type: 'dashed',
            },
            // emphasis: {
            //   itemStyle: {
            //     borderColor: '#fff',
            //     borderWidth: 1,
            //     borderType: 'solid',
            //     opacity: 1
            //   }
            // },
            data: b,
            // data: chartYDataList[i],
            yAxisIndex: item === 'Rank' ? 1 : 0,
            color: '#FBB545'
          }
          series.push(pSerie)
        }
      })
      return series
    } else {
      return {
        name: '',
        type: 'line',
        showSymbol: true,
        data: chartYDataList[0],
      }
    }
  };

  try {
    maxY = Math.max(...(returnSeries()[0].data));
  } catch (err) { }

  const makeupOptions = () => {
    const series = returnSeries() || [];
    let _legend = isPolishing ? {
      type: 'scroll',
      orient: 'horizontal', //横向
      pageIconColor: '#ff781f', //翻页箭头颜色
      selectedMode: true,
      pageIconSize: 13,
      pageTextStyle: {
        color: '#999', //翻页数字颜色
      }, //翻页数字设置
      show: lengendArr ? true : false,
      icon: 'circle',
      itemWidth: 20,
      itemHeight: 10,
      bottom: 10,
      left: 'center',
      formatter: (params: any) => {
        if (params.indexOf('Predicted') !== -1) {
          return `{databrainImg|}{a| ${params}}`
        } else {
          return `{${platform}Img|}{a| ${platformMap[platform] || ''} ${params}}`
        }
      },
      textStyle: {
        rich: {
          a: {
            color: '#888888',
            fontSize: 12,
          },
          databrainImg: {
            height: 16,
            width: 16,
            backgroundColor: {
              image: databrain
            },
          },
          appannieImg: {
            height: 18,
            width: 18,
            backgroundColor: {
              image: appnnie
            },
          },
          sensortowerImg: {
            height: 18,
            width: 18,
            backgroundColor: {
              image: sensortower
            },
          },
        }
      },
      data: series?.map((serie: any) => {
        return {
          name: serie?.name,
          icon: !serie?.isPredict ? 'circle' : PREDICT_DATA_SVG_ICON,
          textStyle: {
            color: '#888888',
          },
        };
      }),
    } : {
      show: false,
    }
    const opts = {
      title: {
        text: '',
      },
      tooltip: {
        trigger: 'axis',
        // backgroundColor: '#FFFFFF',
        borderWidth: 0,
        padding: 0,
        textStyle: {
          color: '#FFFFFF',
          fontSize: 12,
        },
        confine: true,
        hideDelay: 200,
        triggerOn: 'mousemove',
        axisPointer: {
          type: 'line',
        },
        formatter: lineFormatterTooltip,
        backgroundColor: 'rgba(0,0,0,0)'
      },
      legend: _legend,
      grid: {
        left: '1.5%',
        right: '4%',
        bottom: 48,
        top: 10,
        containLabel: true,
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: true,
          axisTick: { show: true, alignWithLabel: true },
          data: chartXDataList,
          axisLabel: {
            formatter: function (value: string) {
              return showTimeByDateType(value, TIMETYPETOLY[dateType]);
            },
            color: '#000000',
            // interval: 0,
            align: 'center',
            fontSize: 12,
            opacity: 0.45,
          },
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            formatter: function (value: any) {
              if (value >= maxY && showUnit.includes(currentType)) {
                return '$' + mathFormat(value);
              } else {
                return mathFormat(value);
              }
            },
            color: ' #000000',
            fontSize: 12,
            opacity: 0.45,
          },
          splitLine: {
            // show: costIncomeRateFlag,
            lineStyle: {
              type: 'dashed',
              color: '#E5E5E5',
            },
          },
          min: 0,
          max: (value: any) => {
            // 没有数据时（操作图例，认为不展示所有数据），y轴最大值设置为100M，防止echarts没数据时，不展示y轴
            if (Number.isNaN(value?.min) && Number.isNaN(value?.max)) {
              return 100 * 1000 * 1000;
            }
            // 返回undefined 或 null，echarts自动根据实际数据 计算 合适的最大值
            return undefined;
          },
        },
      ],
      color: colorArr,
      series,
    };
    if (lengendArr.includes('Rank')) {
      opts.yAxis.push(
        {
          type: 'value',
          min: 1,
          max: function (value: any) {
            const { max } = value;
            if (max < 5) return 5;
            return max;
          },
          minInterval: 1,
          inverse: true,
          splitLine: {
            show: false,
          },
          axisLabel: {
            formatter: '{value}'
          }
        }
      )
    }
    return opts;
  };

  // const lineOption = useMemo(() => {
  //   let opts = makeupOptions();

  //   return opts;
  // }, [props, chartXDataList, chartYDataList]);

  const {
    // 是否展示补齐数据（根据是否开启补齐数据的图例的change事件更新这个值）
    showPredict,
    option: lineOption,
  } = useLineOptionEffect({
    ...props,
    chartsInstance,
    chartXDataList,
    chartYDataList,
    predictByDayArr,
    makeupOptions,
  });

  const onChartEarliestClick = (data: any) => {
    for (let n in chartXData) {
      if (chartXData[n] == data.value) {
        setChartXDataList(chartXData.slice(n));
        let arrTemp = [];
        for (let m in chartYData) {
          arrTemp.push(chartYData[m].slice(n))
        }
        setChartYDataList(arrTemp);
      }
    }
  }

  return (
    <div className="card-line" >
      {enableOpinionEventAnnotation ? (
        <OpinionBarAndLineChart
          ref={chartsInstance}
          chartLoading={trendLoading}
          lineOption={lineOption}
          chartType="line"
          chartHeight={350}
          onChartEarliestClick={onChartEarliestClick}
          enableEventAnnotation
          controlledEventAnnotation={controlledEventAnnotation}
          opinionEventConfig={{
            gameIds: [],
            startTime: '',
            endTime: '',
            dateType,
          }}
        />
      ) : (
        <ChartsIndex
          ref={chartsInstance}
          chartLoading={trendLoading}
          lineOption={lineOption}
          chartType={'line'}
          onChartEarliestClick={onChartEarliestClick}
        />
      )}
    </div>
    // <div className="chart month-kpi-chart" ref={ref} style={style}>
    //   <div id={`game_${chartId}`} style={style} ref={ref}></div>
    // </div>
  );
};

export default LineChart

function useLineOptionEffect(props: any) {
  const {
    // ChartsIndex组件实例
    chartsInstance,
    chartXDataList,
    chartYDataList,
    predictByDayArr,
    makeupOptions,
    ...restProps
  } = props;

  const [showPredict, setShowPredict] = useState(true);
  const [option, setOption] = useState<any>(null);

  const handleLegendselectedChange = useMemoizedFn((payload: any) => {
    const type = payload?.type;
    const name = payload?.name;
    const selected = payload?.selected || {};
    if (type !== 'legendselectchanged' || !name) return;
    const showPredictTmp = Reflect.has(selected, name) ? selected?.[name] : true;
    setShowPredict(showPredictTmp);
  });

  useDeepCompareEffect(() => {
    const optionTmp = makeupOptions() || {};
    let seriesTmp = optionTmp?.series || [];
    // eslint-disable-next-line no-nested-ternary
    seriesTmp = Array.isArray(seriesTmp) ? seriesTmp : seriesTmp ? [seriesTmp] : [];
    seriesTmp = handleSerieSymbolConfig(seriesTmp);
    optionTmp.series = seriesTmp;
    setOption(optionTmp);
  }, [restProps, chartXDataList, chartYDataList, predictByDayArr, showPredict]);

  useEffect(() => {
    const lineChartInstance = chartsInstance?.current?.getLineInstance();
    if (!lineChartInstance) {
      return undefined;
    }

    lineChartInstance.on('legendselectchanged', handleLegendselectedChange);

    return () => {
      lineChartInstance.off('legendselectchanged', handleLegendselectedChange);
    };
  }, [handleLegendselectedChange, option, chartsInstance]);

  return {
    showPredict,
    option,
  };
}
